(() => {
  if (window.tnTubNavigationReady) return;
  window.tnTubNavigationReady = true;
  // Capture before theme anchor handlers so every purchase CTA returns to the page top.
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href="#tub-purchase"]');
    if (!link || !document.querySelector('.tn-tub-draft') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const target = document.querySelector('.product__title h1, .tn-tub-purchase-title');
    if (target) {
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
    history.replaceState(history.state, '', location.pathname + location.search);
    window.scrollTo({ top: 0, left: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }, true);
})();
